import React, { useEffect, useState } from "react";
import { useLoader } from "../../context/LoaderContext";
import {
  IBannerData,
  IConsentLetters,
  ISurgicalData,
} from "../../exports/interfaces";
import {
  fetchConsentLetters,
  fetchRhinoplasty,
  fetchRhinoplastyBanner,
} from "../../api/SurgicalDomainApi";
import { dynamicFailed } from "../../hooks/useToast";
import SurgicalDomainsBanner from "../../components/surgicaldomains/SurgicalDomainsBanner";
import SurgicalDomainsDescription from "../../components/surgicaldomains/SurgicalDomainsDescription";

const Rhinoplasty = () => {
  const { setLoading } = useLoader();
  const [rhinoplastyBanner, setRhinoplastyBanner] = useState<IBannerData[]>([]);
  const [rhinoplastyData, setRhinoplastyData] = useState<ISurgicalData[]>([]);
  const [consentLetters, setConsentLetters] = useState<IConsentLetters[]>([]);

  useEffect(() => {
    setLoading(true);
    Promise.all([
      fetchRhinoplastyBanner(),
      fetchRhinoplasty(),
      fetchConsentLetters(),
    ])
      .then(([rhinoplastyBannerData, rhinoplastyData, consentLettersData]) => {
        setRhinoplastyBanner(rhinoplastyBannerData);
        setRhinoplastyData(rhinoplastyData);
        setConsentLetters(consentLettersData);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      })
      .catch(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        dynamicFailed("Server Error");
      });
  }, [setLoading]);
  return (
    <>
      <SurgicalDomainsBanner
        bannerData={rhinoplastyBanner}
        page={"Rhinoplasty"}
      />
      <SurgicalDomainsDescription descriptionData={rhinoplastyData} consentLetters={consentLetters} surgicalName='Rhinoplasty' />
    </>
  );
};

export default Rhinoplasty;
